import React, { useState } from 'react';
import styled from '@emotion/styled';
import CloseButton, { CLOSE_BUTTON_CLASS_NAME } from './CloseButton';

export interface OverlayProps {
  show: boolean;
  children?: React.ReactNode;
  onClose?: () => any;
  renderFooter?: () => React.ReactNode;
}

const Overlay: React.FC<OverlayProps> = (props) => {
  // When the overlay closes, we want to persist the previous render
  // so that it doesn't disappear while it's closing.
  const [prevRender, setPrevRender] = useState<null | JSX.Element>(null);

  if (props.show === false) {
    return <OverlayContainer show={false}>{prevRender}</OverlayContainer>;
  }

  const handleClose = () => {
    setPrevRender(currentRender);

    if (props.onClose) {
      props.onClose();
    }
  };

  const currentRender = (
    <>
      <CloseButton onClick={handleClose} />
      <div
        className={['inner', props.renderFooter ? 'with-footer' : ''].join(' ')}
      >
        {props.children}
      </div>
      {props.renderFooter && (
        <div className="footer">{props.renderFooter()}</div>
      )}
    </>
  );

  return <OverlayContainer show>{currentRender}</OverlayContainer>;
};

export const OverlayContainer = styled.div<{
  show: boolean;
}>`
  position: fixed;
  top: 10px;
  max-width: 400px;
  width: 100%;
  height: calc(100% - 20px);
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.12), 0px 8px 10px rgba(0, 0, 0, 0.12);
  transition: opacity 0.3s linear, left 0.3s linear;

  ${(props) =>
    props.show
      ? `
    left: calc(100% - 410px);
    opacity: 1;
  `
      : `
    left: calc(100% + 10px);
    opacity: 0;
  `}

  .inner {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: hidden auto;

    &.with-footer {
      height: calc(100% - 82px);
    }
  }

  .${CLOSE_BUTTON_CLASS_NAME} {
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 2;
  }

  .footer {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 82px;
    background: #fff;
    box-shadow: 0px -4px 10px rgba(0, 0, 0, 0.12),
      0px 8px 10px rgba(0, 0, 0, 0.12);
  }
`;

export default Overlay;
